import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ControlBase } from '../../base/control-base/control-base.component';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
    selector: 'button-control',
    templateUrl: 'button.control.html',
    standalone: false,
})
export class ButtonControl extends ControlBase {
    constructor(protected override spinnerService: NgxSpinnerService) {
        super(spinnerService);
    }

    // [onClickAsync]="függvény_neve" --> ezt kell megadni, ha async függvényről van szó (pl. bármilyen szerveroldali kérés)
    @Input() onClickAsync: () => Promise<any>;
    public waiting = false;

    // (onClick)="függvény_neve()" --> ezt kell megadni, ha sync függvényről van szó (pl. egy modal megnyitása)
    @Output() onClick = new EventEmitter<void>();

    @Input() buttonText: string = '';
    @Input() buttonId: string = '';
    @Input() buttonType: string = 'submit';
    @Input() themeColor: string = 'success';
    @Input() buttonDisabled: boolean = false;
    @Input() buttonClass: string = '';
    @Input() shouldTranslated: boolean = true;

    async onClickMethod(): Promise<void> {
        if (!this.onClickAsync) {
            this.onClick.emit();
        } else {
            this.waiting = true;

            try {
                await this.handleSpinner(this.onClickAsync());
            } finally {
                this.waiting = false;
            }
        }
    }
}
